import React from "react";
import "../../TeamManager/styles/teamManagerStyles.css";
import SettingsPageWrapper from "../../../shared/SettingsPageWrapper";
import SettingsPaymentMethodSection from "./SettingsPaymentMethodSection";

const SettingsBillingAndPaymentDetails = ({ settingsPath, lastEditedAt, changelogVersions, team, csrfToken, stripePublishableKey }) => {
  return (
    <SettingsPageWrapper settingsPath={settingsPath} title="Billing & Payments" lastEditedAt={lastEditedAt} changelogVersions={changelogVersions}>
      <div className="team-member-card">
        <div className="team-member-card-header">
          <div className="team-member-card-header-left">
            <div className="team-member-card-title-row">
              <h2 className="team-member-card-title">Billing & Payments</h2>
            </div>
            <p className="team-member-card-subtitle">
              Customize billing and payment settings.
            </p>
          </div>
        </div>
        <hr style={{ margin: 0, border: 'none', borderTop: '1px solid var(--sl-border-secondary, #E9EAEB)' }} />
        <div style={{ padding: 24 }}>
          <SettingsPaymentMethodSection
            team={team}
            csrfToken={csrfToken}
            stripePublishableKey={stripePublishableKey}
          />
        </div>
      </div>
    </SettingsPageWrapper>
  );
};

export default SettingsBillingAndPaymentDetails;
